export const OnboardingStatus = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_REQUIRED: 'NOT_REQUIRED',
};
